import { View } from "react-native";
import { KeyboardSafeViewProps } from "./KeyboardSafeViewProps";

export const KeyboardSafeView = (props: KeyboardSafeViewProps) => {
  return (
    <View style={props.style}>
      {props.children}
    </View>
  );
};